/**
 * Contact Form 7 の date タグに flatpickr を適用
 *
 * - id指定は使用せず、CF7のdateタグ（input[type="date"]）へ適用
 * - AJAX再描画（送信・バリデーション）にも再適用
 * - 二重初期化は _flatpickr ガードで回避
 */
const contactForm7Flatpickr = () => {
  const apply = () => {
    if (!window.flatpickr) return;

    const nodes = document.querySelectorAll('.wpcf7 form input[type="date"]');
    nodes.forEach((el) => {
      if (el._flatpickr) return;

      const fp = window.flatpickr(el, {
        // 送信値（CF7のdate互換）はISO形式のまま
        dateFormat: 'Y-m-d',
        // 表示は日本語フォーマットにする
        altInput: true,
        altFormat: 'Y年m月d日',
        locale: 'ja',
        disableMobile: true,
        allowInput: true,
      });

      // 表示用（altInput）のプレースホルダーを設定
      if (fp && fp.altInput) {
        fp.altInput.setAttribute('placeholder', '年 / 月 / 日');
      }

      // カレンダーアイコンがなければ追加（CF7のPHPは実行されないためJSで補完）
      const container =
        el.closest('.m-form-table__date') || el.closest('.m-form-table__input');
      if (container && !container.querySelector('.m-icon--calendar')) {
        const svgNS = 'http://www.w3.org/2000/svg';
        const xlinkNS = 'http://www.w3.org/1999/xlink';
        const svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('class', 'm-icon m-icon--calendar');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('width', '20');
        svg.setAttribute('height', '20');
        svg.setAttribute('fill', 'currentColor');
        const use = document.createElementNS(svgNS, 'use');
        // href属性（Safari対策でxlink:hrefも併用）
        use.setAttributeNS(null, 'href', '#icon-calendar');
        use.setAttributeNS(xlinkNS, 'xlink:href', '#icon-calendar');
        svg.appendChild(use);
        container.appendChild(svg);
      }
    });
  };

  // 初期化
  apply();

  // CF7のAJAX再描画イベント時に再適用
  document.addEventListener('wpcf7mailsent', apply);
  document.addEventListener('wpcf7invalid', apply);
  document.addEventListener('wpcf7submit', apply);
};

export { contactForm7Flatpickr };
